import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Image from "next/image";
const VaContinueLoginImage = () => {
    return (_jsx("div", { style: { height: "200px" }, children: _jsx(Image, { src: "/completeForgetImg.svg", alt: "", width: 250, height: 250 }) }));
};
export default VaContinueLoginImage;
